var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    _vm._g({ staticClass: "button-filter" }, _vm.$listeners),
    [
      _c("span", [
        _c(
          "svg",
          {
            attrs: {
              xmlns: "http://www.w3.org/2000/svg",
              width: "20",
              height: "20",
              viewBox: "0 0 56.1 60.1"
            }
          },
          [
            _c(
              "g",
              {
                attrs: {
                  id: "Group_1506",
                  "data-name": "Group 1506",
                  transform: "translate(56.05 0.05) rotate(90)"
                }
              },
              [
                _c("path", {
                  attrs: {
                    id: "Path_5230",
                    "data-name": "Path 5230",
                    d:
                      "M7.98,23.08A.235.235,0,0,0,8,23V1A1,1,0,0,0,6,1V23a.235.235,0,0,0,.02.08,6.987,6.987,0,0,0,0,13.84A.235.235,0,0,0,6,37V55a1,1,0,0,0,2,0V37a.235.235,0,0,0-.02-.08,6.987,6.987,0,0,0,0-13.84ZM7,35a5,5,0,1,1,5-5A5,5,0,0,1,7,35Z",
                    fill: "#ffffff",
                    stroke: "#ffffff",
                    "stroke-width": "1"
                  }
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    id: "Path_5231",
                    "data-name": "Path 5231",
                    d:
                      "M30.98,36.08c0-.03.02-.05.02-.08V1a1,1,0,0,0-2,0V36a.235.235,0,0,0,.02.08,6.987,6.987,0,0,0,0,13.84c0,.03-.02.05-.02.08v5a1,1,0,0,0,2,0V50a.235.235,0,0,0-.02-.08,6.987,6.987,0,0,0,0-13.84ZM30,48a5,5,0,1,1,5-5A5,5,0,0,1,30,48Z",
                    fill: "#ffffff",
                    stroke: "#ffffff",
                    "stroke-width": "1"
                  }
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    id: "Path_5232",
                    "data-name": "Path 5232",
                    d:
                      "M60,15a7,7,0,0,0-6.02-6.92A.235.235,0,0,0,54,8V1a1,1,0,0,0-2,0V8a.235.235,0,0,0,.02.08,6.987,6.987,0,0,0,0,13.84c0,.03-.02.05-.02.08V55a1,1,0,0,0,2,0V22a.235.235,0,0,0-.02-.08A7,7,0,0,0,60,15Zm-7,5a5,5,0,1,1,5-5A5,5,0,0,1,53,20Z",
                    fill: "#ffffff",
                    stroke: "#ffffff",
                    "stroke-width": "1"
                  }
                })
              ]
            )
          ]
        )
      ]),
      _vm._v("Dopasuj prezenty"),
      _vm.totalFilters > 0
        ? _c("div", [_vm._v(_vm._s(_vm.totalFilters))])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }